// Services
import { gql } from "@/services/httpAdapter";

// Fragments
import { ReconciliationFragment } from "../fragments/reconciliation";

const updateReconciliationSubscription = (locationId: string, commissionCycleId: string, payPeriodId: string) => ({
	context: "onUpdateReconciliation",
	query: gql`
		subscription onUpdateReconciliation($locationId: String, $commissionCycleId: String, $payPeriodId: String) {
			onUpdateReconciliation(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				locationId
				commissionCycleId
				payPeriodId
				reconciliation {
					...Reconciliation
				}
			}
		}
		${ReconciliationFragment}
	`,
	variables: {
		locationId,
		commissionCycleId,
		payPeriodId,
	},
});

export { updateReconciliationSubscription };
